import { Component } from 'react';

import './smart-checkbox.css';

class SmartCheckbox extends Component {
  update(e) {
    const { on_change, config } = this.props;
    const newValue = e.target.checked;
    on_change(config.name, newValue);
  }

  render() {
    const { config, value } = this.props;
    const label = config.label;
    const name = config.name;
    let isChecked = value;

    if (isChecked === undefined) {
      isChecked = false;
    }

    return (
      <div>
        <label htmlFor={name}>{label}</label>
        <input
          type="checkbox"
          className="regular-checkbox"
          name={name}
          checked={isChecked}
          onChange={this.update.bind(this)}
        />
      </div>
    );
  }
}

export default SmartCheckbox;
